import React, { useState } from 'react';
import useAxiosInstance from '../../hooks/useAxios';
import { toast } from 'react-toastify';
import { HeapChart } from '../../components/Charts/HeapChart';
import FormRender from '../../components/FormRender';
import { REPORT_TRACEBILITY_FORM_CONFIG } from '../../helper';

const mockresponse =
  {
    "status": "success",
    "report_trace":{
        "t354": {
          "queue_time": 1672531200.0,
          "runtime": 200,
          "ready": true,
          "name": "PD - Fire Company Info (Success)",
          "start_time": 1672531205.0,
          "end_time": 1672531225.0,
          "expired": false,
          "history": [],
        },
        "t355": {
          "queue_time": 1672531240.0,
          "runtime": 30,
          "ready": true,
          "name": "PD - Website Crawler (1 Retry)",
          "start_time": 1672531242.0,
          "end_time": 1672531265.0,
          "expired": false,
          "history": [
            {
              "start_time": 1672531210.0,
              "end_time": 1672531240.0, // This attempt failed
              "ready": true,
              "expired": true,
            }
          ],
        },
        "t356": {
          "queue_time": 1672531270.0,
          "runtime": 15, // Runtime set low to show an overrun
          "ready": true,
          "name": "PD - News Tagging (Overrun)",
          "start_time": 1672531272.0,
          "end_time": 1672531295.0,
          "expired": false,
          "history": [],
        },
        "t357": {
          "queue_time": 1672531300.0,
          "runtime": 300,
          "ready": true,
          "name": "PD - News Summary (In Progress)",
          "start_time": 1672531305.0,
          "end_time": null, // Not finished yet
          "expired": false,
          "history": [],
        },
        "t358": {
          "queue_time": 1672531200.0,
          "runtime": 120,
          "ready": false, // Not ready to run
          "name": "PD - Not Ready Task",
          "start_time": null,
          "end_time": null,
          "expired": false,
          "history": [],
        },
        "t359": {
          "queue_time": 1672531305.0,
          "runtime": 100,
          "ready": true,
          "name": "PD - Expired Task (No Retry)",
          "start_time": 1672531312.0,
          "end_time": null,
          "expired": true,
          "history": [],
        },
      },
    "dependency_pairs": [
        [
            "view",
            "v25",
            "t358"
        ],
        [
            "tool",
            "t358",
            "t357"
        ],
        [
            "tool",
            "t357",
            "t355"
        ],
        [
            "tool",
            "t357",
            "t356"
        ],
        [
            "tool",
            "t355",
            "t354"
        ],
        [
            "tool",
            "t356",
            "t354"
        ],
        [
            "view",
            "v3",
            "t358"
        ],
        [
            "tool",
            "t358",
            "t357"
        ],
        [
            "tool",
            "t357",
            "t355"
        ],
        [
            "tool",
            "t357",
            "t356"
        ],
        [
            "tool",
            "t355",
            "t354"
        ],
        [
            "tool",
            "t356",
            "t354"
        ],
        [
            "view",
            "v15",
            "t358"
        ],
        [
            "tool",
            "t358",
            "t357"
        ],
        [
            "tool",
            "t357",
            "t355"
        ],
        [
            "tool",
            "t357",
            "t356"
        ],
        [
            "tool",
            "t355",
            "t354"
        ],
        [
            "tool",
            "t356",
            "t354"
        ],
        [
            "view",
            "v276",
            "t358"
        ],
        [
            "tool",
            "t358",
            "t357"
        ],
        [
            "tool",
            "t357",
            "t355"
        ],
        [
            "tool",
            "t357",
            "t356"
        ],
        [
            "tool",
            "t355",
            "t354"
        ],
        [
            "tool",
            "t356",
            "t354"
        ]
    ]
}


export default function ReportChart() {
  const [formData, setFormData] = useState({ reportId: '' });
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const axiosInstance = useAxiosInstance();
  const [dependencyPairs , setdependancyPairs] = useState("");

  const fetchData = async (id) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(`/workflow_manager/get_report_trace/`,{report_id:id});
      setData(response.data?.report_trace);
      setdependancyPairs(response.data?.dependency_pairs)
      // setdependancyPairs(mockresponse.dependency_pairs)
      // setData(mockresponse.report_trace)
      toast.success(`Data fetched successfully for Report ID: ${id}`);
    } catch (error) {
      console.error("Failed to fetch data", error);
      toast.error(error.response?.data?.message || "Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const reportId = formData.reportId?.trim();
    if (reportId) {
      fetchData(Number(reportId));
    } else {
      toast.error("Please enter a valid Report ID");
    }
  };

  const isValidGraphData = (data) => {
    return data && typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length > 0;
  };

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white border border-gray-200 rounded-lg p-8 mb-6 shadow-sm">
        <div className="text-2xl font-semibold items-center flex justify-between">
          Report Traceability
        </div>
           <form onSubmit={handleFormSubmit} className="flex items-end space-x-4 mb-6">
            <div className="flex-1 max-w-md">
              <FormRender
                formData={formData}
                setFormData={setFormData}
                formSettings={REPORT_TRACEBILITY_FORM_CONFIG}
              />
            </div>
            <button
              type="submit"
              disabled={loading || !formData.reportId?.trim()}
              className="px-6 py-2 bg-black text-white font-medium rounded-lg hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors flex items-center space-x-2"
            >
              {loading ? (
                <>
                  <svg className="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Loading...
                </>
              ) : (
                "Fetch Data"
              )}
            </button>
          </form>
        </div>

        <div className="my-6">
          {loading ? (
            <div className="text-center py-8">Loading...</div>
          ) : !data ? (
            <div className="text-center py-8 text-gray-500">No graph data available.</div>
          ) : !isValidGraphData(data) ? (
            <div className="text-center py-8 text-red-500">Wrong format.</div>
          ) : (
            <HeapChart reportTrace={data} dependencyPairs={dependencyPairs} />
          )}
        </div>
      </div>
    </div>
  );
}   